import { render, staticRenderFns } from "./NoGrantedDisplay.vue?vue&type=template&id=4af2be3a&"
import script from "./NoGrantedDisplay.vue?vue&type=script&lang=js&"
export * from "./NoGrantedDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports